import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'

const ReadyRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        const isSetup = !!rest.isSetup
        return (
          isSetup
          ? <Component {...props} />
          : <Redirect to={{ pathname: `/${rest.config.key}/setup` }} />
        )
      }}
    />
  )
}

const mapStateToProps = (state) => {
  const isSetup = state.session.account.firstName && state.session.account.lastName && state.session.organizations.length != 0
  return { isSetup, config: state.config }
}

export default connect(mapStateToProps)(ReadyRoute)



// WEBPACK FOOTER //
// ./src/components/elements/ReadyRoute.jsx